import React, { useEffect, useRef } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom'; 
import AddBank from './components/AddBank';
import { bankLisitingRequest, deleteBank } from './redux/bankDispatcher';

function BankListingTable({ bankListing }) {
  const paginationModel = { page: 0, pageSize: 10 };
  const dispatch = useDispatch();
  const location = useLocation();

  const bankListingHeading = [
    {
      field: 'id',
      headerName: 'NO',
      width: 60,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: 'name',
      headerName: 'Bank Name',
      width: 300,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center', height: '100%' }}>
            <AddBank
              buttonLabel="Edit"
              editMode={true}
              bankData={params.row}
            />

            <button
              onClick={() => handleDelete(params.row)}
              style={{
                backgroundColor: '#F44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '4px',
                fontSize: '10px',
                width: '60px',
                height: '24px',
                padding: '2px 5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  const handleDelete = (row) => {
    Swal.fire({
      html: `Are you sure?<br>You want to delete bank "${row.name}"`,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: 'gray',
      confirmButtonColor: '#4f83df',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteBank(row.id));
      }
    });
  };

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!fetchedRef.current) {
      fetchedRef.current = true;
      dispatch(bankLisitingRequest());
    }
  }, [dispatch, location.pathname]);

  return (
    <Paper sx={{ height: '95%', width: '100%' }}>
      <div style={{ padding: '10px', justifyItems: 'end' }}>
        <AddBank buttonLabel={"Add Bank"} />
      </div>

      <DataGrid
        rows={bankListing.bankListing || []}
        columns={bankListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
                rowHeight={36}

        loading={bankListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    bankListing: state.bankReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bankLisitingRequest: () => dispatch({ type: 'GET_BANK_REQUEST' }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankListingTable);
